var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1735900175696,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5325,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.26 160m36.7 0l0.1 0q36.7 0 36.7 36.7l0 215.12q0 36.7-36.7 36.7l-0.1 0q-36.7 0-36.7-36.7l0-215.12q0-36.7 36.7-36.7Z",
    fill: "#495057",
    "p-id": 5326
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M405.884192 608.625481m33.945787-14.053865l0 0q33.945787-14.053865 47.999652 19.891923l82.26522 198.703893q14.053865 33.945787-19.891922 47.999652l0 0q-33.945787 14.053865-47.999653-19.891922l-82.265219-198.703894q-14.053865-33.945787 19.891922-47.999652Z",
    fill: "#495057",
    "p-id": 5327
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.869797 847.207987m14.053865-33.945787l82.26522-198.703894q14.053865-33.945787 47.999652-19.891922l0 0q33.945787 14.053865 19.891922 47.999652l-82.265219 198.703893q-14.053865 33.945787-47.999653 19.891923l0 0q-33.945787-14.053865-19.891922-47.999652Z",
    fill: "#495057",
    "p-id": 5328
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.48 227.44m34.34 0l532.36 0q34.34 0 34.34 34.34l0 392.72q0 34.34-34.34 34.34l-532.36 0q-34.34 0-34.34-34.34l0-392.72q0-34.34 34.34-34.34Z",
    fill: "#DEE2E6",
    "p-id": 5329
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M234.98 495.06a25.34 25.34 0 0 1 25.42 25.34v56.6a8 8 0 0 1-8 8h-34.78a8 8 0 0 1-8-8v-56.6a25.34 25.34 0 0 1 25.34-25.34z",
    fill: "#20C997",
    "p-id": 5330
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M325.72 402.84a25.34 25.34 0 0 1 25.34 25.34v148.82a8 8 0 0 1-8 8h-34.7a8 8 0 0 1-8-8v-148.82a25.34 25.34 0 0 1 25.34-25.34z",
    fill: "#228AE6",
    "p-id": 5331
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M416.48 425.9a25.34 25.34 0 0 1 25.34 25.34v125.76a8 8 0 0 1-8 8h-34.7a8 8 0 0 1-8-8v-125.76a25.34 25.34 0 0 1 25.34-25.34z",
    fill: "#20C997",
    "p-id": 5332
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M507.22 310.62A25.34 25.34 0 0 1 532.64 336v241a8 8 0 0 1-8 8h-34.78a8 8 0 0 1-8-8V336a25.34 25.34 0 0 1 25.34-25.34z",
    fill: "#228AE6",
    "p-id": 5333
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M62 206.8m17.16 0l621.68 0q17.16 0 17.16 17.16l0 21.14q0 17.16-17.16 17.16l-621.68 0q-17.16 0-17.16-17.16l0-21.14q0-17.16 17.16-17.16Z",
    fill: "#868E96",
    "p-id": 5334
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62 646.04m17.16 0l621.68 0q17.16 0 17.16 17.16l0 21.14q0 17.16-17.16 17.16l-621.68 0q-17.16 0-17.16-17.16l0-21.14q0-17.16 17.16-17.16Z",
    fill: "#868E96",
    "p-id": 5335
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M751.8 285.7a81.84 81.7 0 1 0 163.68 0 81.84 81.7 0 1 0-163.68 0Z",
    fill: "#FC7070",
    "p-id": 5336
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M915.24 390.96H602.96c-19.36 0-36 14.84-36.92 34.14a36 36 0 0 0 36 37.62h124.92A23.36 23.36 0 0 1 750.24 486v331.32A46.72 46.72 0 0 0 797 864h73.26a46.72 46.72 0 0 0 46.76-46.68v-134.14a23.34 23.34 0 0 1 15.22-21.6A46.62 46.62 0 0 0 962 618.14v-180.5a46.72 46.72 0 0 0-46.76-46.68z",
    fill: "#FC7070",
    "p-id": 5337
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatForm);
export default __webpack_public_path__ + "static/media/StatForm.caaec7d49f103f404f80969328c8a23c.svg";
export { ForwardRef as ReactComponent };